<template>
    <VPopover class="user-card__popover" popoverClass="popover-light" trigger="hover" @show="onPopoverShow">
        <UserCard
            :status="status"
            :short-name="shortName"
            :picture-only="pictureOnly"
            :multiline="multiline"
            :account="account"
        ></UserCard>

        <template slot="popover">
            <UserCard
                class="user-card__popover-user prevent-close"
                :short-name="shortName"
                :account="account"
            ></UserCard>

            <div class="user-card__popover-info prevent-close">
                <span class="user-card__popover-info-row">Почта: {{ account.email }}</span>
                <br />
                <span class="user-card__popover-info-row">Должность: {{ account.title }}</span>
                <br />
                <span class="user-card__popover-info-row">Город: {{ account.location }}</span>
                <br />
                <span class="user-card__popover-info-row">Компания: {{ account.company }}</span>
                <br />
                <span class="user-card__popover-info-row">Отдел: {{ account.department }}</span>
                <br />
                <span class="user-card__popover-info-row">Телефон: {{ account.telephone }}</span>
            </div>

            <div class="user-card__popover-equipment prevent-close" v-if="$_canViewInventory && !equipmentError">
                <div class="user-card__popover-equipment-title">Оборудование</div>

                <span class="user-card__popover-equipment-status" v-if="equipmentLoading">Загрузка...</span>

                <span class="user-card__popover-equipment-status" v-else-if="!equipment.length">Не закреплено</span>

                <ul class="user-card__popover-equipment-list" v-else>
                    <li v-for="item in displayEquipment" :key="item.id" class="user-card__popover-equipment-item">
                        {{ item.name }}<template v-if="serialNumber(item)"> — с/н {{ serialNumber(item) }}</template
                        ><template v-if="item.warranty_expire_at"
                            >, гарантия до {{ $_toLocalDateHistory(item.warranty_expire_at) }}</template
                        >
                    </li>
                </ul>
            </div>
        </template>
    </VPopover>
</template>

<script>
// Components
import UserCard from './UserCard.vue';

// Other
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { getAccountEquipment } from '@/js/accountEquipmentCache';

@Component({
    components: {
        UserCard,
    },
})
class UserCardWithPopover extends Vue {
    @Prop({ type: String, default: '' })
    status;

    @Prop({ type: Object, default: () => ({}) })
    account;

    @Prop({ type: Boolean, default: false })
    shortName;

    @Prop({ type: Boolean, default: false })
    pictureOnly;

    @Prop({ type: Boolean, default: false })
    multiline;

    equipment = [];
    equipmentLoading = false;
    equipmentError = false;

    get displayEquipment() {
        return this.equipment.slice(0, 5);
    }

    serialNumber(item) {
        const attribute = item.attributes.find((a) => a.type === 'Серийный номер');

        return attribute ? attribute.value : null;
    }

    onPopoverShow() {
        // Право просмотра инвентаря, а не роль: у наблюдателя роли исполнителя может
        // не быть вовсе, а блок ему полагается. И наоборот — исполнитель без прав
        // на инвентарь получит с бэкенда пустой список, так что запрос ему не нужен.
        if (!this.$_canViewInventory || !this.account.id) {
            return;
        }

        // Фиксируем id на момент запроса: экземпляр переиспользуется, и проп account может смениться,
        // пока ответ в пути — устаревший ответ не должен трогать состояние.
        const accountId = this.account.id;

        this.equipmentLoading = true;

        getAccountEquipment(accountId)
            .then((equipment) => {
                if (this.account.id !== accountId) {
                    return;
                }

                this.equipment = equipment;
                this.equipmentError = false;
            })
            .catch(() => {
                if (this.account.id !== accountId) {
                    return;
                }

                this.equipmentError = true;
            })
            .finally(() => {
                if (this.account.id !== accountId) {
                    return;
                }

                this.equipmentLoading = false;
            });
    }
}

export default UserCardWithPopover;
</script>

<style lang="scss">
.user-card {
    &__popover {
        display: flex;
    }

    &__popover-info {
        min-width: 320px;
        margin: 12px -16px -6px -16px;
        padding: 12px 0 0 0;
        border-top: 1px solid #e4eaef;
    }

    &__popover-info-row {
        display: inline-block;
        margin: 0 16px;
        padding: 6px 0;
        font-size: 0.875rem;
        line-height: 1rem;
        color: #484848;
    }

    &__popover-equipment {
        min-width: 320px;
        margin: 0 -16px -6px -16px;
        padding: 8px 16px 6px 16px;
        border-top: 1px solid #e4eaef;
    }

    &__popover-equipment-title {
        margin-bottom: 4px;
        font-size: 0.875rem;
        font-weight: 600;
        color: #484848;
    }

    &__popover-equipment-status,
    &__popover-equipment-item {
        font-size: 0.8125rem;
        line-height: 1.2rem;
        color: #484848;
    }

    &__popover-equipment-list {
        margin: 0;
        padding: 0 0 0 16px;
    }
}
@media (max-width: $mobile-breakpoint) {
    .user-card__popover-info {
        max-width: 175px;
    }
}
</style>
